import { SxProps, Theme } from "@mui/material";

export const popupPaper: SxProps<Theme> = {
    position: "relative",
    m: 2,
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "visible",
};

export const popupImage: SxProps<Theme> = {
    display: "block",
    maxWidth: "100%",
    maxHeight: "80vh",
    border: (theme: Theme) => `4px solid ${theme.palette.white}`,
};

export const closeButton: SxProps<Theme> = {
    position: "absolute",
    top: 12,
    right: 12,
    color: (theme: Theme) => theme.palette.hsvBlue,
    backgroundColor: (theme: Theme) => theme.palette.white,
    "&:hover": {
        backgroundColor: (theme: Theme) => theme.palette.white,
        opacity: 0.9,
    },
};
